import store from "@/state/store";
import Layout from "@/router/layouts/vertical";

export default [
  {
    path: "",
    redirect: "/dashboard",
  },
  {
    path: "/sso/authorize",
    name: "sso",
    component: () => import("@/router/views/authorize.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      authRequired: true,
    },
  },
  // {
  //   path: '/dashboard',
  //   name: 'dashboard',
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import('./views/dashboards/default'),
  // },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },

  {
    path: "/dashboard",
    component: Layout,
    children: [
      // 首页
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("./views/dashboards/default"),
      },

      // 文章发布

      {
        path: "/articlePublish",
        name: "articlePublish",
        component: () => import("./views/articlePublish/article"),
        meta: { power: ["创作平台-文章发布"] },
      },

      // 文章详情
      {
        path: "/articleDetail",
        name: "articleDetail",
        component: () => import("./views/articlePublish/detail"),
        meta: { power: ["创作平台-文章发布"] },
        // meta: { power: ["内容-文章"] },
      },
      // 视频发布
      {
        path: "/videoPublish",
        name: "videoPublish",
        component: () => import("./views/videoPublish/index"),
        meta: { power: ["创作平台-视频发布"] },
      },
      // 视频发布详细
      {
        path: "/videoPublishDetail",
        name: "videoPublishDetail",
        component: () => import("./views/videoPublish/detail"),
        meta: { power: ["创作平台-视频发布"] },
      },
      //问卷管理
      {
        path: "/questionManage",
        name: "questionManage",
        component: () => import("./views/answerManage/questionManage/index"),
        meta: { power: ["创作平台-问卷管理"] },
      },
      {
        path: "/questionAdd",
        name: "questionAdd",
        component: () => import("./views/answerManage/questionManage/add"),
        meta: { power: ["创作平台-问卷管理"] },
      },
      {
        path: "/questionTopic",
        name: "questionTopic",
        component: () => import("./views/answerManage/questionManage/topic"),
        meta: { power: ["创作平台-问卷管理"] },
      },
      {
        path: "/performance",
        name: "performance",
        component: () => import("./views/answerManage/questionManage/score"),
        meta: { power: ["创作平台-问卷管理"] },
      },
      //题库管理
      {
        path: "/questionBank",
        name: "questionBank",
        component: () => import("./views/answerManage/questionBank/index"),
        meta: { power: ["创作平台-题库管理"] },
      },

      // 门店管理
      {
        path: "/shops",
        name: "shops",
        component: () => import("./views/shops/list"),
      },
      //圈子评论管理
      {
        path: "/circleReview",
        name: "circleReview",
        component: () => import("./views/circleReview/index"),
        meta: { power: ["创作平台-圈子评论管理"] },
      },
      // 用户管理
      {
        path: "/userInfo",
        name: "userInfo",
        component: () => import("./views/users/userInfo"),
        meta: { power: ["创作平台-用户中心"] },
      },
      // 用户管理-修改头像
      {
        path: "/userAvatar",
        name: "userAvatar",
        component: () => import("./views/users/avatar"),
        meta: { power: ["创作平台-用户中心"] },
      },
      // 用户管理-修改昵称
      {
        path: "/userNickName",
        name: "userNickName",
        component: () => import("./views/users/nickname"),
        meta: { power: ["创作平台-用户中心"] },
      },
      // 用户管理-修改密码
      {
        path: "/userPassword",
        name: "userPassword",
        component: () => import("./views/users/password"),
        meta: { power: ["创作平台-用户中心"] },
      },
      // 用户管理-修改手机号
      {
        path: "/userPhoneNumber",
        name: "userPhoneNumber",
        component: () => import("./views/users/phoneNumber"),
        meta: { power: ["创作平台-用户中心"] },
      },
      {
        path: "/question",
        name: "question",
        component: () => import("./views/question/list"),
      },
      {
        path: "/questionAdd",
        name: "questionAdd",
        component: () => import("./views/question/add"),
      },
      {
        path: "/questionAttends",
        name: "questionAttends",
        component: () => import("./views/question/attends"),
      },

      // 优惠券列表
      {
        path: "/coupons",
        name: "coupons",
        component: () => import("./views/coupons/coupon/list.vue"),
        meta: { power: "slideshow-review" },
      },
      // 优惠券详情
      {
        path: "/couponDetail",
        name: "couponDetail",
        component: () => import("./views/coupons/coupon/detail.vue"),
        meta: { power: "slideshow-review" },
      },
      // 优惠券领用列表
      {
        path: "/couponsReceive",
        name: "couponsReceive",
        component: () => import("./views/coupons/coupon/receiveList.vue"),
        meta: { power: "slideshow-review" },
      },
      // 第三方优惠券
      {
        path: "/thirdPartyCoupons",
        name: "thirdPartyCoupons",
        component: () => import("./views/coupons/coupon/thirdPartyList.vue"),
        meta: { power: "slideshow-review" },
      },
      // 优惠券核销列表
      {
        path: "/couponWriteOff",
        name: "couponWriteOff",
        component: () => import("./views/coupons/writeOff/index.vue"),
        meta: { power: "slideshow-review" },
      },
      // 优惠券操作日志列表
      {
        path: "/couponLog",
        name: "couponLog",
        component: () => import("./views/coupons/log/index.vue"),
        meta: { power: "slideshow-review" },
      },
      // 优惠券操作日志列表
      {
        path: "/redPacketHistory",
        name: "redPacketHistory",
        component: () => import("./views/videoPublish/redPacketReceive"),
        meta: { power: "slideshow-review" },
      },
      // 优惠券操作日志列表
      {
        path: "/couponHistory",
        name: "couponHistory",
        component: () => import("./views/videoPublish/couponReceive"),
        meta: { power: "slideshow-review" },
      },
      // 圈子管理
      {
        path: "/group",
        name: "group",
        component: () => import("./views/group/group"),
        meta: { power: ["创作平台-圈子管理"] },
      },
      //圈子详情
      {
        path: "/groupContent",
        name: "groupContent",
        component: () => import("./views/group/content.vue"),
        meta: { power: ["创作平台-圈子管理"] },
      },
      //运营人员管理
      {
        path: "/operator",
        name: "operator",
        component: () => import("./views/operator/operator.vue"),
        meta: { power: ["创作平台-运营人员管理"] },
      },

      // 媒体号角色详情
      {
        path: "/mediaRoleDetail",
        name: "mediaRoleDetail",
        component: () => import("./views/roles/detail.vue"),
        meta: { power: ["创作平台-角色管理"] },
      },
      // 媒体号角色管理
      {
        path: "/mediaRole",
        name: "mediaRole",
        component: () => import("./views/roles/list.vue"),
        meta: { power: ["创作平台-角色管理"] },
      },
      //创建运营人员
      {
        path: "/createOperator",
        name: "createOperator",
        component: () => import("./views/operator/createOperator.vue"),
        meta: { power: ["创作平台-运营人员管理"] },
      },

      {
        path: "/media",
        name: "media",
        component: () => import("./views/media/media.vue"),
        meta: { power: ["创作平台-媒体号管理"] },
      },
      // 文章评论
      {
        path: "/articleComments",
        name: "articleComments",
        component: () => import("./views/comments/content-comment/list.vue"),
        meta: { power: ["创作平台-文章发布"] },
      },
      // 视频评论
      {
        path: "/videoComments",
        name: "videoComments",
        component: () => import("./views/comments/content-comment/list.vue"),
        meta: { power: ["创作平台-视频发布"] },
      },
      {
        path: "/topicManage",
        name: "topicManage",
        component: () => import("./views/topicManage/Index.vue"),
        meta: { power: ["话题-列表"] },
      },
      {
        path: "/topicContent",
        name: "topicContent",
        component: () => import("./views/topicManage/content/content.vue"),
        meta: { power: ["话题-内容管理"] },
      },
      {
        path: "/topicComment",
        name: "topicComment",
        component: () => import("./views/comments/topic-comment/list.vue"),
        meta: { power: ["话题-回复"] },
      },
    ],
  },
];
